import type { StringObject } from '~/types/common'

export interface LocalizationDto {
  $schema?: string
  key: string
  translations: StringObject
}

export type SupportedLocale = 'en-US' | 'fr-CA' | 'es-ES'

interface LanguageOption {
  label: string
  key: SupportedLocale
}

export const options: LanguageOption[] = [
  { label: 'En', key: 'en-US' },
  { label: 'Fr', key: 'fr-CA' },
  { label: 'Es', key: 'es-ES' }
]
